import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createLectureQuizQuestion as createLectureQuizQuestionApi } from "../../../../services/dashboard/apiQuizes";
import toast from "react-hot-toast";

export function useCreateQuizQuestions() {
  const queryClient = useQueryClient();

  const {
    mutate: createQuizQuestion,
    isPending: isCreating,
    error,
  } = useMutation({
    mutationFn: createLectureQuizQuestionApi,
    onSuccess: () => {
      toast.success("تم إضافة سؤال بنجاح");
      queryClient.invalidateQueries({
        queryKey: ["quizQuestionsDB"],
      });
    },

    onError: (error) => {
      toast.error(error.response.data.message);
    },
  });

  return { createQuizQuestion, isCreating, error };
}
